import { useUrlStateParams } from '../../utils/url'

/**
 * @description URL state for a detail page's edit dialog. `?edit=t` opens the editor at the top and
 * `?edit=<section id>` opens it scrolled to that section, so per-section edit buttons are deep-linkable.
 */
export function useEditSectionParam() {
  const [editParam, setEditParam] = useUrlStateParams<string>(
    '',
    'edit',
    (value) => value,
    (value) => value,
  )
  return {
    isEditing: editParam !== '',
    editSection: editParam && editParam !== 't' ? editParam : undefined,
    openEditor: (sectionId?: string) => setEditParam(sectionId || 't'),
    closeEditor: () => setEditParam(''),
  }
}
